import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/atc/ATC CREAM venilla.png";
import BiscuitImg from "../../../assets/products/atc/ATC-Vanilla.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 125,
  },
  {
    grams: 150,
  },
];

export default function VanillaATCProduct() {
  return (
    <>
      <Helmet>
        <title>
          ATC Vanilla Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz ATC Vanilla Cream Biscuits — classic vanilla-flavored cream biscuits in ATC format. View pack sizes and global specifications."
        />
        <meta
          name="keywords"
          content="ATC Vanilla Cream Biscuit, BearBitz ATC Vanilla"
        />
        <link rel="canonical" href="https://www.bearbitz.in/atc/vanilla" />
        <meta
          property="og:title"
          content="ATC Vanilla Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Vanilla cream biscuit in ATC format with export-ready packaging and premium flavor."
        />
      </Helmet>

      <ProductTemplate
        productTitle="VANILLA"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in The rich taste of ATC Cream Biscuits, where every crunchy bite meets a smooth and creamy filling."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#9F794D"
        sectionBgColor="#FFD5A7"
        productBgcolor="#FFE6CB"
        tableheadBgcolor="#9F794D"
        tableBgcolor="#FFF3E5"
        footerBgcolor="#9F794D"
      />
    </>
  );
}
